import { Skeleton } from "@mui/material";
import type { FC } from "react";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";

export const CalculatorResultSkeletonRow: FC = () => (
	<LabeledValueRow
		label={<Skeleton variant="text" width={96} height={16} animation="wave" />}
		value={<Skeleton variant="text" width={112} height={16} animation="wave" />}
	/>
);
